const CONST = require('plugin_frontend_core/constants');
// CommonJS approach, should use ES6 but entire project uses CommonJS.
// Restricted to using Swiper v6 because is it the last version to support CommonJS.
const Swiper = require('swiper').default;
const Navigation = require('swiper').Navigation;
const Pagination = require('swiper').Pagination;
const Scrollbar = require('swiper').Scrollbar;

Swiper.use([Navigation, Pagination, Scrollbar]);

/**
 * @function
 * @description Define Page Designer Swiper instances
 */

function initPDSwiper() {
    if ( $('.js-pd-slider').length > 0 ) {

        let pdSliders = document.querySelectorAll('.js-pd-slider');

        pdSliders.forEach(function(element, i) {
            let pdSwiperConfig = JSON.parse(element.getAttribute('data-swiper'));

            element.setAttribute('id', 'swiper-' + i);

            var $nextEl = '#swiper-' + i + ' > .swiper-navigation .swiper-button-next';
            var $prevEl = '#swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
            var $pagination = '#swiper-' + i + ' > .swiper-pagination';

            additionalConfig = {
                grabCursor: true,
                observeParents: true,
                observer: true,
                resizeObserver: true,
                watchOverflow: true,
                touchMoveStopPropagation: true,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl,
                },
                pagination: {
                    el: $pagination
                }
            }

            // Combine properties
            pdSwiperConfig = Object.assign({}, pdSwiperConfig, additionalConfig);

            let pdSwiper = new Swiper(element, pdSwiperConfig);
        });
    }
}

/**
 * @function
 * @description Define Page Designer landing page Swiper instances
 */

function initLandingSwiper() {
    if ( $('.js-landing-slider').length > 0 ) {

        let landingSliders = document.querySelectorAll('.js-landing-slider');

        landingSliders.forEach(function(element) {
            let instructions = element.querySelector('.instruction-slide__container');

            let landingSwiperConfig = new Swiper(element, {
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                on: {
                    init: function() {
                        // Add empty slide to offset
                        const emptySlide = document.createElement('div');
                        emptySlide.classList.add('js-landing-carousel-item', 'swiper-slide');
                        this.slides[0].parentNode.insertBefore(emptySlide, this.slides[0]);

                        this.update();
                    },
                    slideChangeTransitionEnd: function() {
                        // Hide instructions after swiping
                        if (this.activeIndex === 1) {
                            if (instructions) {
                                instructions.classList.add('hidden');
                            }
                        }
                    },
                    slideChangeTransitionStart: function() {
                        // Show instructions after swiping back
                        if (this.activeIndex === 0) {
                            if (instructions) {
                                instructions.classList.remove('hidden');
                            }
                        }
                    }
                }
            });
        });
    }
}

/**
 * @function
 * @description Define Recommended Products Swiper instances
 */

function initRecommendedSwiper() {
    if ( $('.js-product-slider').length > 0 ) {

        let productSliders = document.querySelectorAll('.js-product-slider');

        productSliders.forEach(function(element, i) {
            element.setAttribute('id', 'swiper-' + i);

            var $nextEl =  '#swiper-' + i + ' > .swiper-navigation .swiper-button-next';
            var $prevEl = '#swiper-' + i + ' > .swiper-navigation .swiper-button-prev';
            var $scrollBar = '#swiper-' + i + ' > .swiper-scrollbar-container .swiper-scrollbar';

            let productSwiper = new Swiper(element, {
                grabCursor: true,
                observeParents: true,
                observer: true,
                resizeObserver: true,
                slidesPerView: 2,
                slidesPerGroup: 1,
                watchOverflow: true,
                touchMoveStopPropagation: true,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl,
                },
                scrollbar: {
                    el: $scrollBar,
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                    1280: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                    }
                }
            });
        });
    }
}

/**
 * @function
 * @description Define attribute Swiper instances for product tile quickview
 */
function initAttrSwiper() {
    if ( $('.js-attr-slider').length > 0 ) {

        let attrSliders = document.querySelectorAll('.js-attr-slider');

        attrSliders.forEach(function(element, i) {
            element.setAttribute('id', 'attr-swiper-' + i);

            var $nextEl = '#attr-swiper-' + i + ' + .swiper-navigation .swiper-button-next';
            var $prevEl = '#attr-swiper-' + i + ' + .swiper-navigation .swiper-button-prev';

            let attrSwiper = new Swiper(element, {
                loop: false,
                centerInsufficientSlides: false,
                grabCursor: true,
                slidesPerView: 'auto',
                slidesPerGroup: 3,
                observeParents: true,
                observer: true,
                resizeObserver: true,
                nested: true,
                watchOverflow: true,
                touchMoveStopPropagation: true,
                navigation: {
                    nextEl: $nextEl,
                    prevEl: $prevEl,
                },
            });

            // Set no-swiping class to container if there is nothing to swipe, to remove the padding
            if ( $($nextEl).hasClass('swiper-button-lock') && $($prevEl).hasClass('swiper-button-lock') ) {
                $('#attr-swiper-' + i).closest('.product-attributes__container').addClass('no-swiping');
            }
        });
    }
}

/**
 * @function
 * @description Initialize
 */
function init() {
    initPDSwiper();
    initLandingSwiper();
    initRecommendedSwiper();
    initAttrSwiper();
}

module.exports = {
    init: init,
    initRecommendedSwiper: initRecommendedSwiper,
    initAttrSwiper: initAttrSwiper
};
